import {NavSections} from "./NavSections";

export const NavigationItems = [
  {
    title: 'Dataforensics',
    tags: 'Dataforensics ',
    icon: 'fal fa-cogs',
    navSection: NavSections.developer | NavSections.dataforensics,
    auth: '',
    items: [
      {
        navSection:  NavSections.developer | NavSections.dataforensics,
        auth: '',
        title: 'Organizations',
        tags: 'Dataforensics Organizations',
        routerLink: '/dataforensics/organizations'
      },
      {
        navSection:  NavSections.developer | NavSections.dataforensics,
        auth: '',
        title: 'Sales Orgs',
        tags: 'Dataforensics Sales',
        routerLink: '/dataforensics/sales'
      },
      {
        navSection: NavSections.developer | NavSections.dataforensics,
        auth: 'true',
        title: 'Errors',
        tags: 'Errors',
        routerLink: '/about/errors'
      },
      {
        navSection:  NavSections.developer | NavSections.dataforensics,
        auth: '',
        title: 'MapServers',
        tags: 'Dataforensics MapServers',
        routerLink: '/dataforensics/mapservers'
      },
      {
        title: 'Users',
        tags: 'Dataforensics Users\'',
        icon: 'fal fa-id-card-o ',
        navSection: NavSections.developer | NavSections.dataforensics,
        auth: '',
        items: [
          {
            navSection: NavSections.developer | NavSections.dataforensics,
            auth: '',
            title: 'Users',
            tags: 'Dataforensics Users',
            routerLink: '/dataforensics/users'
          },
          {
            navSection: NavSections.developer | NavSections.dataforensics,
            auth: '',
            title: 'Microsoft Users',
            tags: 'Microsoft Users',
            routerLink: '/dataforensics/microsoftusers'
          },
          {
            navSection: NavSections.developer | NavSections.dataforensics,
            auth: '',
            title: 'Find Users',
            tags: 'Dataforensics Users Find',
            routerLink: '/dataforensics/finduser'
          },
          {
            navSection: NavSections.developer | NavSections.dataforensics,
            auth: '',
            title: 'Find Device',
            tags: 'Dataforensics Device Find',
            routerLink: '/dataforensics/finddevice'
          }
        ]
      },
      {
        title: 'License',
        tags: 'Dataforensics License\'',
        icon: 'fal fa-id-card-o ',
        navSection: NavSections.developer | NavSections.dataforensics,
        auth: '',
        items: [
          {
            navSection: NavSections.developer | NavSections.dataforensics,
            title: 'Active Licenses',
            tags: 'NavSections.developer | NavSections.dataforensics,',
            auth: '',
            routerLink: '/dataforensics/activelicenses'
          },
          {
            navSection: NavSections.developer | NavSections.dataforensics,
            auth: '',
            title: 'Deleted Licenses',
            tags: 'NavSections.developer | NavSections.dataforensics,',
            routerLink: '/dataforensics/deletedlicenses'
          }
        ]
      },
      
      {
        title: 'CPT',
        tags: 'Dataforensics CPT\'',
        icon: 'fal fa-id-card-o ',
        navSection: NavSections.developer | NavSections.dataforensics,
        auth: '',
        items: [
          {
            navSection: NavSections.developer | NavSections.dataforensics,
            auth: '',
            title: 'Projects',
            tags: 'Dataforensics CPTProject',
            routerLink: '/dataforensics/CPTProject'
          }
        ]
      },
      {
        title: 'DataExplorers',
        tags: 'Dataforensics dataexplorers\'',
        icon: 'fal fa-id-card-o ',
        navSection: NavSections.developer | NavSections.dataforensics,
        auth: '',
        items: [
          {
            navSection: NavSections.developer | NavSections.dataforensics,
            auth: '',
            title: 'Dataexplorers',
            tags: 'Dataforensics DataExplorers',
            routerLink: '/dataforensics/dataexplorers'
          }
        ]
      }
    ]
  },
  {
    title: 'Client',
    tags: 'Client Functions',
    icon: 'fal fa-globe',
    navSection:   NavSections.Member | NavSections.dataforensics,
    auth: 'true',
    items: [
      {
        navSection:   NavSections.developer | NavSections.dataforensics ,
        auth: 'View Projects',
        title: 'Projects',
        tags: 'application Client Projects',
        routerLink: '/clients/projects'
      },
      {
        navSection:  NavSections.developer | NavSections.dataforensics ,
        auth: 'View Sampling Plans',
        title: 'Sampling Plans',
        tags: 'application Client Sampling Plans',
        routerLink: '/clients/samplingplans'
      },
      {
        navSection:  NavSections.developer | NavSections.dataforensics ,
        auth: 'View configurations',
        title: 'Configurations',
        tags: 'application Client configurations',
        routerLink: '/clients/configurations'
      },
      {
        navSection:  NavSections.developer | NavSections.dataforensics ,
        auth: 'View PlogIC',
        title: 'pLogIC',
        tags: 'application Client pLogIC',
        routerLink: '/clients/plogics'
        },
        {
          navSection: NavSections.Member | NavSections.dataforensics,
          auth: 'Convert Lab Data',
          title: 'Lab Data Converter',
          tags: 'application Client lab',
          routerLink: '/clients/lab/hub'
      },
        {
          navSection: NavSections.Member | NavSections.dataforensics,
          auth: 'Upload and Convert DIGGS Files',
          title: 'DIGGS',
          tags: 'application Client lab',
          routerLink: '/clients/diggs/files'
      },
      {
        title: 'Enterprise',
        tags: 'Client Enterprise\'',
        icon: 'fal fa-id-card-o ',
        navSection: NavSections.developer | NavSections.dataforensics,
        auth: 'View Logos|View Offices|View Support Notification|View Coordinate Systems',
        items: [
          {
            navSection:  NavSections.developer | NavSections.dataforensics ,
            auth: 'View Logos',
            title: 'Logos',
            tags: 'application Client Logos',
            routerLink: '/clients/logos'
          },
          {
            navSection:  NavSections.developer | NavSections.dataforensics ,
            auth: 'View Offices',
            title: 'Offices',
            tags: 'application Client Offices',
            routerLink: '/clients/offices'
          },
          {
            navSection: NavSections.developer | NavSections.dataforensics ,
            auth: 'View Support Notification',
            title: 'Support Notifications',
            tags: 'application Client Support',
            routerLink: '/clients/notifications'
          } ,
          {
            navSection:  NavSections.developer | NavSections.dataforensics ,
            auth: 'View Coordinate Systems',
            title: 'Coordinates',
            tags: 'application Client Coordintes',
            routerLink: '/clients/coordtree'
          },
          {
            navSection: NavSections.developer | NavSections.dataforensics ,
            auth: 'View Coordinate Systems',
            title: 'Map Servers',
            tags: 'application Client Map Servers',
            routerLink: '/clients/mapserver/mapservers'
          }
        ]
      },
      {
        title: 'Application',
        tags: 'Client Application\'',
        icon: 'fal fa-id-card-o ',
        navSection: NavSections.developer | NavSections.dataforensics,
        auth: 'View Users|View Active Licenses|View Security Groups',
        items: [
          {
            navSection:  NavSections.developer | NavSections.dataforensics ,
            auth: 'View Users',
            title: 'Users',
            tags: 'application Client users',
            routerLink: '/clients/users'
          },
          {
            navSection:  NavSections.developer | NavSections.dataforensics ,
            auth: 'View Active Licenses',
            title: 'Licenses',
            tags: 'application Client Licenses',
            routerLink: '/clients/licenses'
          },
          {
            navSection:  NavSections.developer | NavSections.dataforensics ,
            auth: 'View Security Groups',
            title: 'Security Groups',
            tags: 'application Client authorizations',
            routerLink: '/clients/securitygroups'
          }
        ]
      }

    ]
  },
  {
    title: 'Help',
    tags: 'Help',
    icon: 'fal fa-info-circle',
    navSection: NavSections.Member | NavSections.developer | NavSections.dataforensics,
    auth: 'true',
    items: [
      {
        navSection: NavSections.public | NavSections.Member | NavSections.developer | NavSections.dataforensics,
        auth: 'true',
        title: 'Help',
        tags: 'Help',
        routerLink: '/about/Help'
      },
      {
        navSection: NavSections.public | NavSections.Member | NavSections.developer | NavSections.dataforensics,
        auth: 'true',
        title: 'Forums',
        tags: 'Forums',
        routerLink: '/about/forums'
      }
    ]
  },

  {
    navSection: NavSections.Member | NavSections.developer | NavSections.dataforensics,
    auth: 'true',
    title: 'Settings',
    tags: 'settings',
    icon: 'fal fa-cog',
    items: [
      {
        title: 'Layout Options',
        tags: 'theme settings layout options',
        routerLink: '/settings/layout-options',
        navSection: NavSections.Member | NavSections.developer | NavSections.dataforensics,
        auth: 'true',
      },
    ]
  },
    
];
